import { treePlanting } from "../routes";

const claimDailyTurn = async (data) => {
  try {
    const response = await fetch(treePlanting.claimDailyTurnRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
      const result = await response.json();
      return result;
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const checkDailyTurn = async (userEventId, event) => {
  try {
    const response = await fetch(
      `${treePlanting.checkDailyTurnRoute}?userEventId=${userEventId}&event=${event}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const waterTree = async (data) => {
  try {
    const response = await fetch(treePlanting.waterTreeRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    
    const result = await response.json();
    
    if (response.ok) {
      return result;
    } else {
      // Trả về result ngay cả khi không ok để xử lý error message
      return result;
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getUserTreeInfo = async (userEventId, event) => {
  try {
    const response = await fetch(
      `${treePlanting.getUserTreeInfoRoute}?userEventId=${userEventId}&event=${event}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getUserRewards = async (userEventId, event, page = 1, limit = 20) => {
  try {
    const response = await fetch(
      `${treePlanting.getUserRewardsRoute}?userEventId=${userEventId}&event=${event}&page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getUserStatistics = async (userEventId, event) => {
  try {
    const response = await fetch(
      `${treePlanting.getUserStatisticsRoute}?userEventId=${userEventId}&event=${event}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getLeaderboard = async (event, page = 1, limit = 3) => {
  try {
    const response = await fetch(
      `${treePlanting.getLeaderboardRoute}?event=${event}&page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getTop3 = async (event) => {
  try {
    const response = await fetch(
      `${treePlanting.getTop3Route}?event=${event}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getTop10Submissions = async (event) => {
  try {
    const response = await fetch(
      `${treePlanting.getTop10SubmissionsRoute}?event=${event}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getTop10Rewards = async (event) => {
  try {
    const response = await fetch(
      `${treePlanting.getTop10RewardsRoute}?event=${event}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

// Export functions for downloading all data (no pagination)
const getAllLeaderboard = async (event) => {
  try {
    const response = await fetch(
      `${treePlanting.getLeaderboardRoute}?event=${event}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getAllRewards = async (event) => {
  try {
    const response = await fetch(
      `${treePlanting.getRewardsRoute}?event=${event}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      },
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const exportRewardsJSON = async (event) => {
  try {
    const response = await fetch(
      `${treePlanting.exportRewardsJSONRoute}?event=${event}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      }
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export {
  claimDailyTurn,
  checkDailyTurn,
  waterTree,
  getUserTreeInfo,
  getUserRewards,
  getUserStatistics,
  getLeaderboard,
  getTop3,
  getTop10Submissions,
  getTop10Rewards,
  getAllLeaderboard,
  getAllRewards,
  exportRewardsJSON,
};
